import { fileSelectorKey } from '.';
export var createFileSelectorDriver = function (wrapper) {
    var base = wrapper.$("." + fileSelectorKey);
    return {
        selectFile: function (file) { return Promise.resolve(window.testFileSelectHook(file)); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map